import React from 'react';
import { Link } from 'react-router-dom';

const HeroSection: React.FC = () => {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden bg-gradient-to-br from-blue-50 via-white to-indigo-50">
      {/* 背景图片 */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://readdy.ai/api/search-image?query=Modern%20bioinformatics%20laboratory%20with%20DNA%20sequencing%20machines%2C%20computer%20screens%20displaying%20genomic%20data%20analysis%2C%20molecular%20biology%20equipment%20and%20scientific%20instruments%2C%20clean%20minimalist%20laboratory%20environment%20with%20blue%20lighting%2C%20focus%20on%20technology%20and%20equipment%20without%20showing%20people%20or%20hands&width=1920&height=1080&seq=hero-bg-v2&orientation=landscape"
          alt="生物信息学研究背景"
          className="w-full h-full object-cover object-top opacity-20"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-blue-50/90 via-white/80 to-indigo-50/90"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 w-full">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* 左侧内容 */}
          <div className="text-left">
            <div className="mb-6">
              <span className="inline-block bg-blue-100 text-blue-800 px-4 py-2 rounded-full text-sm font-medium">
                专业科研服务提供商
              </span>
            </div>
            
            <h1 className="text-5xl lg:text-6xl font-bold text-gray-900 mb-6 leading-tight">
              让您的<span className="text-blue-600">科研数据</span><br />
              转化为<span className="text-blue-600">高质量论文</span>
            </h1>
            
            <p className="text-xl text-gray-600 mb-8 leading-relaxed">
              我们以严谨的实验技术、成熟的分析体系和可验证的科研逻辑，为每一项研究提供扎实可靠的科学支撑。
            </p>

            {/* 核心服务领域 */}
            <div className="mb-8">
              <h3 className="text-lg font-semibold text-gray-900 mb-4">核心服务领域</h3>
              <div className="grid grid-cols-2 gap-3">
                <div className="flex items-center text-gray-700">
                  <i className="ri-check-double-line text-blue-600 mr-2"></i>
                  <span>组学数据分析</span>
                </div>
                <div className="flex items-center text-gray-700">
                  <i className="ri-check-double-line text-blue-600 mr-2"></i>
                  <span>机器/深度学习</span>
                </div>
                <div className="flex items-center text-gray-700">
                  <i className="ri-check-double-line text-blue-600 mr-2"></i>
                  <span>研究思路指导</span>
                </div>
                <div className="flex items-center text-gray-700">
                  <i className="ri-check-double-line text-blue-600 mr-2"></i>
                  <span>论文润色服务</span>
                </div>
              </div>
            </div>

            {/* 专长研究方向 */}
            <div className="mb-8">
              <h3 className="text-lg font-semibold text-gray-900 mb-4">专长研究方向</h3>
              <div className="flex flex-wrap gap-2">
                {['肿瘤学', '免疫学', '衰老', '发育生物学', '神经退行性疾病', '心脑血管疾病', '代谢疾病', 'AI4Science'].map((field, index) => (
                  <span key={index} className="bg-blue-50 text-blue-700 px-3 py-1 rounded-full text-sm font-medium">
                    {field}
                  </span>
                ))}
              </div>
            </div>

            <div className="flex justify-center sm:justify-start">
              <Link 
                to="/contact"
                className="bg-blue-600 text-white px-8 py-4 rounded-lg hover:bg-blue-700 transition-colors font-medium text-lg whitespace-nowrap cursor-pointer inline-flex items-center"
              >
                <i className="ri-phone-line mr-2"></i>
                联系我们
              </Link>
            </div>
          </div>

          {/* 右侧统计数据 */}
          <div className="lg:pl-12">
            <div className="grid grid-cols-2 gap-6">
              <div className="bg-white/80 backdrop-blur-sm rounded-xl p-6 shadow-lg">
                <div className="text-3xl font-bold text-blue-600 mb-2">100+</div>
                <div className="text-gray-600">成功项目</div>
                <div className="text-sm text-gray-500 mt-1">已协助发表多篇10+ SCI期刊</div>
              </div>
              <div className="bg-white/80 backdrop-blur-sm rounded-xl p-6 shadow-lg">
                <div className="text-3xl font-bold text-green-600 mb-2">20+</div>
                <div className="text-gray-600">合作机构</div>
                <div className="text-sm text-gray-500 mt-1">清化大学、北京大学、北京协和医学院、中科院、首都医科大学及附属医院等科研机构</div>
              </div>
              <div className="bg-white/80 backdrop-blur-sm rounded-xl p-6 shadow-lg">
                <div className="text-3xl font-bold text-purple-600 mb-2">99%</div>
                <div className="text-gray-600">客户满意度</div>
                <div className="text-sm text-gray-500 mt-1">专业团队，质量保证</div>
              </div>
              <div className="bg-white/80 backdrop-blur-sm rounded-xl p-6 shadow-lg">
                <div className="text-3xl font-bold text-orange-600 mb-2">&lt;24h</div>
                <div className="text-gray-600">平均响应</div>
                <div className="text-sm text-gray-500 mt-1">快速响应，专业对接</div>
              </div>
            </div>

            {/* 团队优势 */}
            <div className="mt-8 bg-white/80 backdrop-blur-sm rounded-xl p-6 shadow-lg">
              <h3 className="text-lg font-semibold text-gray-900 mb-3">团队优势</h3>
              <ul className="space-y-2 text-sm text-gray-600">
                <li className="flex items-start">
                  <i className="ri-star-fill text-yellow-500 mr-2 mt-0.5"></i>
                  学术指导团队由清北、Harvard、MIT等顶尖高校的专家学者构成
                </li>
                <li className="flex items-start">
                  <i className="ri-star-fill text-yellow-500 mr-2 mt-0.5"></i>
                  核心执行成员均为top高校博士
                </li>
                <li className="flex items-start">
                  <i className="ri-star-fill text-yellow-500 mr-2 mt-0.5"></i>
                  深谙高水平期刊审稿标准与学术逻辑
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
